<template>
    <div class="g-container">
        <div class="m-container m-width">
            <!--            面包屑-->
            <div class="crumbs-box">
                <a class="c-crumbs"
                   href="">匠心记</a>
                <span class="c-sep">></span>
                <span class="c-current">创建现场基础情况告知流程</span>
            </div>

            <div class="inform-title">
                <img src="../../../../html/pages/originality/newJxjApply/images/ico-Inform.png" alt="">
                <span>创建现场基础情况告知流程</span>
            </div>
            <div class="content">
                <div class="a-orig-column">
                    <div class="div-form">
                        <h4>现场基础情况异常</h4>
                    </div>
                    <div class="apply-form">
                        <div class="apply-form-row">
                            <el-input v-model="form1.title"
                                      placeholder="请填写项目名称">
                            </el-input>
                        </div>
                    </div>
                </div>
                <div class="a-orig-column">
                    <div class="div-form">
                        <h4>请选择项目类型（可多选）</h4>
                    </div>
                    <div class="apply-form">
                        <div class="apply-form-row">
                            <!--选中 +active-->
                            <span class="apply-tag"
                                  :class="{'active':tag.active}"
                                  v-for="(tag,t) in tags"
                                  @click="chooseTags(t)"
                                  :key="t">{{tag.title}}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="a-orig-column">
                    <div class="div-form">
                        <h4>项目工程师</h4>
                    </div>
                    <div class="apply-form" v-show="showBtn">
                        <div class="apply-form-row-engineer">
                            <el-button class="the-engineer" @click="dialogVisible = true">+点此添加项目工程师</el-button>
                        </div>
                    </div>
                </div>

                <div class="apply-form-row-list" v-show="show" v-for="(item,index) in nameListIndex" :key="item.Id">
                    <div class="apply-form-row-list-left" style="width: 35%">
                        <span class="apply-form-row-list-ico"><img
                                :src="item.HeadImage" alt=""
                                style="width: 40px; height: 40px; border-radius: 20px"></span>
                        <span class="apply-form-row-list-name" >{{item.NickName}}</span>
                    </div>
                    <div class="apply-form-row-list-right">
                        <span class="apply-form-row-list-ico">{{item.PhoneNumber}}</span>
                    </div>
                </div>

                <div class="a-orig-column">
                    <div class="div-form">
                        <h4>客户电话</h4>
                    </div>
                    <div class="apply-form">
                        <div class="apply-form-row">
                            <el-input v-model="form1.mobile"
                                      placeholder="请填写客户电话"
                                      maxlength="11">
                            </el-input>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cm-form-btn">
                <div class="cu-form-btn-cz"
                     @click="submitStep1">重置
                </div>
                <div class="cu-form-btn-qd"
                     @click="submitStep2">确定
                </div>
            </div>
        </div>


        <el-dialog
                id="list-dialog"
                :append-to-body="true"
                :visible.sync="dialogVisible"
                center
                width="725px">
            <div class="dialog-div">
                <div class="dialog-list" v-for="(item,index) in nameList" @click="createName(item)" :key="item.Id">
                    <img :src="item.HeadImage" alt=""
                         style="width: 70px; height: 70px; border-radius: 40px"> <br><br>
                    <span>{{item.NickName}}</span>
                    <br>
                    <span>{{item.PhoneNumber}}</span>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import '../../../../html/components/crumbs/crumbs.scss';
    import '../../../../html/pages/originality/newJxjApply/apply.scss';
    import '../../../../html/pages/originality/modifyProject/modifyProject.scss';
    import '../../../../html/pages/originality/newJxjApply/inForm.css';
    import {
        getJxjTags,
        uploadImage,
        GetJxjProUserTypes,
        GetJxjProUsers,
        jxjAddProjectLog,
        getParentProInfos,
        GetJxjProUser,
        addInfo
    } from '../../../../api';
    import {mapState, mapMutations} from 'vuex';

    export default {
        name: "inForm",
        data() {
            return {
                showBtn: true,
                show: false,
                dialogVisible: false,
                tags: [],
                nameList: [],
                nameListIndex: [],
                setp: 1,
                persons: [],
                setp1Dir: false,
                parentIds: [],
                form1: {
                    parentId: '',
                    title: '',//项目名称
                    // createdTime: '',//创建时间
                    desc: '',//项目简介
                    picPath: '',//图片
                    tagIds: [],//标签
                    nameItems: [],//人员
                    productName: '',//产品名称
                    productPart: '',//产品组成
                    productTrait: '',//产品特点
                    quality: '',//工程质量
                    cycle: '',//工程周期
                    scale: '',//工程规模
                    proUsers: [],
                    mobile: '',//电话
                },
            }
        },
        methods: {
            async getJxjTags() {
                let res = await getJxjTags();
                if (res.Type == 'Success') {
                    res.Data.forEach(item => {
                        item.active = false;
                    });
                    console.log(res.Data,'tags')
                    this.tags = res.Data;

                } else {
                    this.$layer.alert(res.Content);
                }
            },
            async getParentProInfos() {
                let res = await getParentProInfos();
                if (res.Type == 'Success') {
                    this.parentIds = res.Data;

                }
            },
            async GetJxjProUser() {
                let res = await GetJxjProUser();
                this.form1.nameItems = [];
                if (res.Type == 'Success') {
                    this.nameList = res.Data;
                    this.nameList.forEach(item => {
                        this.form1.nameItems.push(item)
                    })
                }

            },
            chooseTags(i) {
                this.tags[i].active = !this.tags[i].active;
                this.form1.tagIds = [];
                this.tags.forEach(item => {
                    if (item.active) {
                        this.form1.tagIds.push(item.id);
                    }
                })
            },

            async getUserByPhone(phone, callback) {
                let res = await GetJxjProUsers({
                    phone: phone
                })
                if (callback) {
                    callback(res);
                }

            },
            // async GetJxjProUserTypes() {
            //     let res = await GetJxjProUserTypes();
            //     if (res.Type == 'Success') {
            //         res.Data.forEach(item => {
            //             item.arr = [];
            //             item.proAddUser = null;
            //             item.searchPhone = '';
            //             item.searchName = '这边显示昵称';
            //         })
            //         res.Data.forEach(item => {
            //             if (item.id <= 7) {
            //                 this.persons.push(item)
            //             }
            //         })
            //         // this.persons = res.Data;
            //         this.getUserByPhone(this.userInfo.phone, res => {
            //             res.Data.isDir = false;
            //             this.persons[0].arr.push(res.Data);
            //         });
            //     }
            // },

            //选择添加工程师
            createName(item) {
                this.nameListIndex.push(item)
                this.dialogVisible = false;
                this.show = true;
                this.showBtn = false;

            },
            //重置
            submitStep1() {
            },
            //确定
            submitStep2() {
                const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if (this.form1.mobile == '' || this.form1.mobile.length !== 11 || !reg.test(this.form1.mobile)) {
                    this.$message({
                        message: "请填写正确的手机号！！",
                        duration: 1000
                    });
                    return
                }
                if (this.form1.title==''){
                    this.$message({
                        message: "请输入项目名称！！",
                        duration: 1000
                    });
                    return
                }
                addInfo({
                    Id:0,
                    ProName:this.form1.title,
                    YzkTagIds: "," + this.form1.tagIds + ",",
                    ProUserIds: "," + this.nameListIndex[0].Id + ",",
                    CustomPhone: this.form1.mobile
                }).then(res=>{
                    console.log(res)
                    console.log(this.form1)
                    this.form1.nameListIndex = this.nameListIndex
                    localStorage.setItem('createAdd', JSON.stringify(this.form1))
                    this.$router.push({
                        path: 'upload',
                        query:{
                            Id:res.Data
                        }
                    });
                })


            },
            // computed: {
            //     ...mapState(['userInfo'])
            // },
        },
        created() {
            this.getJxjTags();
            this.getParentProInfos();
            // this.GetJxjProUserTypes();
            this.GetJxjProUser();
        },
        mounted() {
            console.log(this.form1.nameItems, '人员')
        },
    }
</script>

<style scoped>
    .g-container {
        width: 100%;
        height: 940px;
        background: #FFFFFF;
        font-size: 16px;
    }

    .inform-title {
        width: 100%;
        height: 64px;
        line-height: 64px;
        border-bottom: 2px solid #D0D0D0;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #3C3C3C;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .inform-title img {
        width: 24px;
        height: 20px;
        margin: 0;
        padding-left: 10px;
    }

    .inform-title span {
        padding-left: 10px;
    }

    .a-orig-column {
        margin-bottom: 20px;
    }

    .div-form {
        margin-bottom: 10px;
    }

    .content {
        margin-top: 30px;
    }

    .the-engineer {
        width: 300px;
        height: 40px;
        background: linear-gradient(0deg, #F4F4F4, #FFFFFF);
        border: 1px solid #E8E8E8;
        box-shadow: 0px 1px 2px 0px rgba(170, 170, 170, 0.3);
        border-radius: 6px;
        color: #969696;
        font-size: 14px;
    }

    .cm-form-btn {
        border: 0;
        margin-top: 100px;
    }

    .cm-form-btn .cu-form-btn-cz {
        width: 140px;
        height: 40px;
        background: #B8B8B8;
        border-radius: 20px;
        line-height: 40px;
        color: #ffffff;
        margin-right: 10px;
    }

    .cm-form-btn .cu-form-btn-qd {
        width: 140px;
        height: 40px;
        background: #FF0000;
        border-radius: 20px;
        line-height: 40px;
        color: #ffffff;
        margin-left: 10px;
    }

    /*#list-dialog {*/
    /*    width: 725px;*/
    /*    height: 307px;*/
    /*    display: flex;*/
    /*    justify-content: center;*/
    /*    align-items: center;*/
    /*    flex-wrap: wrap;*/
    /*    border-radius: 20px;*/
    /*}*/
    .dialog-div {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        font-size: 16px;
        text-align: center;
        border-radius: 20px;
    }

    .dialog-list {
        width: 20%;
    }

    .el-dialog--center .el-dialog__body {
        padding: 0;
    }

    .apply-form-row-list {
        width: 35%;
        height: 75px;
        background: #FFffff;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 30px;
    }

    .apply-form-row-list-left {
        width: 25%;
        display: flex;
        align-items: center;
        justify-content: space-around;
    }

    .apply-form-row-list-right {
        width: 30%;
        display: flex;
        align-items: center;
        justify-content: space-around;
    }

    .apply-form-row-list-right-ico {
        width: 40px;
        height: 40px;
    }

    .apply-form-row-list-left-text {
    }
</style>